<template>
  <div class="container">
    <h4>User Profile</h4>
    <div class="row">
      <div class="col-sm-6">
        <table class="table">
          <tbody>
            <tr>
              <td class="bold">Name</td>
              <td>{{ userProfile.first_name }} {{ userProfile.last_name }}</td>
            </tr>
            <tr>
              <td class="bold">Email</td>
              <td>{{ userProfile.email }}</td>
            </tr>
            <tr>
              <td class="bold">Roles</td>
              <td>{{ roles }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<style scoped>
td.bold {
  font-weight: bold;
}
</style>

<script>
import _ from 'underscore'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      userProfile: 'user'
    }),
    ...{
      roles () {
        return _.sortBy(_.pluck(this.userProfile.roles, 'name')).join(', ')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// UserProfile.vue?6099a3af